export interface HideEndChatWarningAction {
    type: "HIDE_END_CHAT_WARNING";
    payload: {
        stateLocation: string;
    };
}

export interface ShowEndChatWarningAction {
    type: "SHOW_END_CHAT_WARNING";
    payload: {
        stateLocation: string;
    };
}

export interface UpdateChatSessionStateAction {
    type: "UPDATE_CHAT_SESSION_STATE";
    payload: {
        stateLocation: string;
        sessionState: string;
    };
}

export const hideEndChatWarningAction = (stateLocation: string): HideEndChatWarningAction => {
    return {
        type: "HIDE_END_CHAT_WARNING",
        payload:
        {
            stateLocation,
        },
    };
};

export const showEndChatWarningAction = (stateLocation: string): ShowEndChatWarningAction => {
    return {
        type: "SHOW_END_CHAT_WARNING",
        payload:
        {
            stateLocation,
        },
    };
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-endchat-warning-overlay/src/actions/actions.ts